import { render, staticRenderFns } from "./SideFormDetail.vue?vue&type=template&id=048f735d&"
import script from "./SideFormDetail.vue?vue&type=script&lang=js&"
export * from "./SideFormDetail.vue?vue&type=script&lang=js&"
import style0 from "./SideFormDetail.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports